import React from 'react'

export default function Error404() {
  return (
    <div>404</div>
  )
}
